/* CoreLink — theme behaviour
   Every initialiser is idempotent and re-runs on shopify:section:load,
   so sections stay alive when they're added or moved in the theme editor. */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = window.matchMedia('(max-width: 860px)');
  var isMobile = MOBILE.matches;
  (MOBILE.addEventListener ? MOBILE.addEventListener.bind(MOBILE, 'change')
                           : MOBILE.addListener.bind(MOBILE))(function (e) { isMobile = e.matches; });
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (window.CoreLink && window.CoreLink.moneyFormat)
      ? window.CoreLink.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
                                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      : '$' + (cents / 100).toFixed(2);
  };

  /* ============ reveals ============ */
  var revealIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('cl-in'); revealIO.unobserve(e.target); }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  function initReveals(root) {
    $$('.cl-rv', root).forEach(function (el) {
      if (!el.dataset.rvBound) { el.dataset.rvBound = '1'; revealIO.observe(el); }
    });
  }

  /* ============ sequenced beads (problem section) ============ */
  function initSeq(root) {
    $$('[data-seq]', root).forEach(function (el) {
      if (el.dataset.seqBound) return; el.dataset.seqBound = '1';
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          $$('.cl-bead', e.target).forEach(function (b, i) {
            setTimeout(function () { b.classList.add('cl-in'); }, RM ? 0 : i * 430);
          });
          io.unobserve(e.target);
        });
      }, { threshold: 0.35 });
      io.observe(el);
    });
  }

  /* ============ conversation ============ */
  function initConv(root) {
    $$('[data-conv]', root).forEach(function (el) {
      if (el.dataset.convBound) return; el.dataset.convBound = '1';
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var items = $$('.cl-bub', e.target);
          items.forEach(function (b, i) { setTimeout(function () { b.classList.add('cl-in'); }, RM ? 0 : i * 520); });
          var done = $('.cl-conv__done', e.target);
          if (done) setTimeout(function () { done.classList.add('cl-in'); }, RM ? 0 : items.length * 520 + 320);
          io.unobserve(e.target);
        });
      }, { threshold: 0.25 });
      io.observe(el);
    });
  }

  /* ============ calendar drop ============ */
  function initCal(root) {
    $$('[data-cal]', root).forEach(function (el) {
      if (el.dataset.calBound) return; el.dataset.calBound = '1';
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cl-in'); io.unobserve(e.target); } });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ============ counters ============ */
  function countUp(el, target, prefix, suffix) {
    prefix = prefix || ''; suffix = suffix || '';
    if (RM) { el.textContent = prefix + target.toLocaleString('en-US') + suffix; return; }
    var t0 = null, dur = 1500;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = clamp((ts - t0) / dur, 0, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(target * e).toLocaleString('en-US') + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters(root) {
    $$('[data-counters]', root).forEach(function (el) {
      if (el.dataset.cntBound) return; el.dataset.cntBound = '1';
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          $$('[data-count]', e.target).forEach(function (n, i) {
            setTimeout(function () {
              countUp(n, parseFloat(n.dataset.count) || 0, n.dataset.prefix || '', n.dataset.suffix || '');
            }, i * 110);
          });
          io.unobserve(e.target);
        });
      }, { threshold: 0.35 });
      io.observe(el);
    });
  }

  /* ============ 24/7 ring ============ */
  function initRing(root) {
    $$('[data-ring]', root).forEach(function (el) {
      if (el.dataset.ringBound) return; el.dataset.ringBound = '1';
      var ticks = $('.cl-ticks', el);
      if (ticks && !ticks.children.length) {
        for (var t = 0; t < 24; t++) {
          var i = document.createElement('i');
          i.style.transform = 'rotate(' + (t * 15) + 'deg)';
          i.style.transformOrigin = '50% 50%';
          i.style.top = '0'; i.style.height = '100%'; i.style.background = 'transparent';
          i.style.borderTop = '11px solid rgba(255,255,255,' + (t % 6 === 0 ? '.3' : '.12') + ')';
          ticks.appendChild(i);
        }
      }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var p = $('[data-ring-progress]', e.target);
          if (p) { p.style.transition = 'stroke-dashoffset 2.6s cubic-bezier(.22,.61,.36,1)'; p.style.strokeDashoffset = '0'; }
          io.unobserve(e.target);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ============ industry selector ============ */
  function initIndustries(root) {
    $$('[data-industries]', root).forEach(function (el) {
      if (el.dataset.indBound) return; el.dataset.indBound = '1';
      var tabs = $$('.cl-tab', el), panes = $$('.cl-envpane', el);
      function show(i) {
        tabs.forEach(function (t, n) { t.classList.toggle('cl-on', n === i); t.setAttribute('aria-selected', n === i); });
        panes.forEach(function (p, n) { p.classList.toggle('cl-on', n === i); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (ev) {
          if (ev.key === 'ArrowRight' && tabs[i + 1]) { tabs[i + 1].focus(); show(i + 1); }
          if (ev.key === 'ArrowLeft' && tabs[i - 1]) { tabs[i - 1].focus(); show(i - 1); }
        });
      });
      /* mobile: swipe between industries */
      var env = $('.cl-env', el), x0 = null, cur = 0;
      if (env) {
        env.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        env.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 55) return;
          cur = tabs.findIndex(function (t) { return t.classList.contains('cl-on'); });
          var next = clamp(cur + (dx < 0 ? 1 : -1), 0, tabs.length - 1);
          show(next);
          if (tabs[next]) tabs[next].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }, { passive: true });
      }
    });
  }

  /* ============ floating panels (parallax) ============ */
  var floaters = [];
  function initFloat(root) {
    $$('[data-float]', root).forEach(function (el) {
      if (el.dataset.floatBound) return; el.dataset.floatBound = '1';
      floaters.push(el);
    });
  }

  /* ============ call sequence (the phone) ============ */
  var sequences = [];
  function initSequence(root) {
    $$('[data-sequence]', root).forEach(function (el) {
      if (el.dataset.seqInit) return; el.dataset.seqInit = '1';
      var inst = {
        root: el,
        copy: $('[data-seq-copy]', el),
        stage: $('[data-seq-stage]', el),
        glow: $('[data-seq-glow]', el),
        hint: $('[data-seq-hint]', el),
        rail: $('[data-seq-rail]', el),
        steps: $('[data-seq-steps]', el),
        stepLabel: $('[data-seq-steps] .cl-steps__label', el),
        stepDots: $$('[data-seq-steps] .cl-steps__dots i', el),
        labels: $$('.cl-pane', el).map(function (p) {
          if (p.dataset.stepLabel) return p.dataset.stepLabel;
          var l = p.querySelector('.cl-label');
          return l ? l.textContent.trim() : '';
        }),
        railItems: $$('[data-seq-rail] > div', el),
        panes: $$('.cl-pane', el),
        timer: $('[data-seq-timer]', el),
        waves: $$('[data-wave]', el),
        pinned: el.dataset.sequence === 'pinned',
        last: -1,
        amp: 0.35
      };
      sequences.push(inst);

      /* static mode auto-advances on a timer once it enters view */
      if (!inst.pinned) {
        var i = 0, timer = null;
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && !timer) {
              timer = setInterval(function () {
                i = (i + 1) % inst.panes.length;
                setPane(inst, i);
              }, 2600);
            } else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.3 });
        io.observe(el);
        setPane(inst, 0);
      }
    });
  }

  function setPane(inst, idx) {
    if (idx === inst.last) return;
    inst.panes.forEach(function (el, i) { el.classList.toggle('cl-on', i === idx); });
    inst.railItems.forEach(function (el, i) { el.classList.toggle('cl-on', i === idx); });
    inst.stepDots.forEach(function (el, i) { el.classList.toggle('cl-on', i === idx); });
    if (inst.stepLabel && inst.labels[idx]) inst.stepLabel.textContent = inst.labels[idx];
    inst.last = idx;
    inst.amp = idx === 0 ? 0.35 : (idx === 1 ? 1 : 0.15);
  }

  function drawWaves(ts) {
    sequences.forEach(function (inst) {
      var r = inst.root.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      inst.waves.forEach(function (w) {
        var bars = w.children;
        for (var i = 0; i < bars.length; i++) {
          var n = Math.sin(ts / 220 + i * 0.55) * Math.sin(ts / 430 + i * 0.21);
          bars[i].style.height = (4 + Math.abs(n) * 30 * inst.amp * 2.4).toFixed(1) + 'px';
        }
      });
    });
  }

  /* ============ header theme ============ */
  var header;
  function headerTick() {
    if (!header) header = $('[data-header]');
    if (!header) return;
    header.classList.toggle('cl-solid', window.scrollY > 40);
    var light = false, probe = header.offsetHeight * 0.6;
    $$('[data-theme="light"]').forEach(function (s) {
      var b = s.getBoundingClientRect();
      if (b.top <= probe && b.bottom >= probe) light = true;
    });
    header.classList.toggle('cl-light', light);
  }

  /* ============ master loop ============ */
  function frame(ts) {
    sequences.forEach(function (inst) {
      if (!inst.pinned) return;
      var r = inst.root.getBoundingClientRect();
      var total = inst.root.offsetHeight - window.innerHeight;
      var p = clamp(-r.top / (total || 1), 0, 1);

      if (inst.copy) {
        var cp = clamp(p / (isMobile ? 0.20 : 0.18), 0, 1);
        inst.copy.style.opacity = (1 - cp).toFixed(3);
        inst.copy.style.transform = 'translateY(' + (-70 * cp) + 'px)';
      }
      if (inst.hint) inst.hint.style.opacity = clamp(1 - (p / 0.18) * 1.4, 0, 1).toFixed(3);

      var dp, y, sc, op;
      if (isMobile) {
        /* the device is already visible at rest, cropped by the bottom edge,
           then rises into frame as the copy clears out — no empty middle */
        dp = clamp(p / 0.22, 0, 1);
        y = 250 - 272 * dp;
        sc = 0.955 + 0.045 * dp;
        op = 1;
      } else {
        dp = clamp((p - 0.13) / 0.20, 0, 1);
        y = (1 - dp) * 90 - p * 40;
        sc = 0.86 + 0.14 * dp;
        op = clamp(dp * 1.3, 0, 1);
      }
      if (inst.stage) {
        inst.stage.style.transform = 'translateY(' + y.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
        inst.stage.style.opacity = op.toFixed(3);
      }
      if (inst.glow) {
        inst.glow.style.opacity = (0.35 + 0.55 * dp).toFixed(3);
        inst.glow.style.transform = 'translate(-50%,-50%) scale(' + (0.8 + 0.35 * dp).toFixed(3) + ')';
      }
      if (inst.rail) inst.rail.style.opacity = dp.toFixed(3);
      if (inst.steps) inst.steps.style.opacity = clamp(dp * 1.6 - 0.15, 0, 1).toFixed(3);

      var sp = clamp((p - 0.20) / 0.77, 0, 1);
      var idx = Math.min(inst.panes.length - 1, Math.floor(sp * inst.panes.length));
      setPane(inst, idx);

      if (inst.timer && idx === 1) {
        var s = Math.floor(2 + (sp * inst.panes.length - 1) * 22);
        inst.timer.textContent = '00:' + String(clamp(s, 2, 59)).padStart(2, '0');
      }
    });

    if (!isMobile) floaters.forEach(function (el) {
      var b = el.getBoundingClientRect();
      var mid = (b.top + b.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = 'translateY(' + (mid * -26).toFixed(1) + 'px) perspective(1600px) rotateX(' + clamp(mid * 2.2, -2.4, 2.4).toFixed(2) + 'deg)';
    });

    headerTick();
    if (!RM) drawWaves(ts);
    requestAnimationFrame(frame);
  }

  /* ============ mobile menu ============ */
  function initMenu() {
    var burger = $('[data-burger]');
    if (!burger || burger.dataset.bound) return;
    burger.dataset.bound = '1';
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('cl-menu-open');
      burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('[data-menu] a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('cl-menu-open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { document.body.classList.remove('cl-menu-open'); document.body.style.overflow = ''; }
    });
  }

  /* ============ toast ============ */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cl-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<b></b><span></span>';
    toastEl.querySelector('span').textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ============ cart ============ */
  var drawer;
  function openDrawer() {
    drawer = drawer || $('[data-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = $('[data-drawer-close]', drawer);
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?sections=cl-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cl-cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-drawer-inner]');
        var live = $('[data-drawer-inner]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        var count = tmp.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = count ? count.textContent : el.textContent;
          el.classList.toggle('is-empty', (count ? count.textContent : '0').trim() === '0');
        });
        bindCartControls();
      });
  }

  function changeLine(key, qty) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('cl-template-cart')) { window.location.reload(); return; }
        return refreshCart();
      });
  }

  function bindCartControls() {
    $$('[data-line-change]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        changeLine(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });
    $$('[data-drawer-close]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', closeDrawer);
    });
  }

  function initCart() {
    drawer = $('[data-drawer]');
    if (drawer && !drawer.dataset.bound) {
      drawer.dataset.bound = '1';
      var veil = $('[data-drawer-veil]', drawer);
      if (veil) veil.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    }
    $$('[data-cart-open]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
    bindCartControls();
  }

  /* ============ product form ============ */
  function initProductForm(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form.dataset.bound) return; form.dataset.bound = '1';
      var btn = $('.cl-atc', form);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!btn || btn.disabled) return;
        btn.classList.add('is-loading');
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (r) { return r.json(); })
          .then(function (data) {
            btn.classList.remove('is-loading');
            if (data.status) { toast(data.description || data.message || 'Could not add to cart.'); return; }
            btn.classList.add('is-done');
            setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
            return refreshCart().then(openDrawer);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            toast('Something went wrong. Try again.');
          });
      });
    });
  }

  /* ============ variants ============ */
  function initVariants(root) {
    $$('[data-variants]', root).forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      var data = JSON.parse($('[data-variant-json]', el).textContent);
      var idInput = $('[data-variant-id]', el);
      var priceEl = $('[data-variant-price]', el);
      var compareEl = $('[data-variant-compare]', el);
      var btn = $('.cl-atc', el);
      var btnLabel = btn ? $('span', btn) : null;

      function selected() {
        return $$('[data-option-group]', el).map(function (g) {
          var on = $('[aria-checked="true"]', g);
          return on ? on.dataset.value : null;
        });
      }
      function update() {
        var sel = selected();
        var match = data.find(function (v) {
          return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price); compareEl.hidden = false;
          } else { compareEl.hidden = true; }
        }
        if (btn) {
          btn.disabled = !match.available;
          if (btnLabel) btnLabel.textContent = match.available ? (btn.dataset.label || 'Add to cart') : 'Sold out';
        }
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          history.replaceState({}, '', u);
        }
      }
      $$('[data-option-group]', el).forEach(function (g) {
        $$('.cl-swatch', g).forEach(function (sw) {
          sw.addEventListener('click', function () {
            $$('.cl-swatch', g).forEach(function (s) { s.setAttribute('aria-checked', 'false'); });
            sw.setAttribute('aria-checked', 'true');
            update();
          });
        });
      });
      update();
    });
  }

  /* ============ gallery ============ */
  function initGallery(root) {
    $$('[data-gallery]', root).forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      var main = $('[data-gallery-main] img', el);
      $$('[data-gallery-thumb]', el).forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.src = t.dataset.full;
          main.srcset = '';
          main.alt = t.dataset.alt || main.alt;
          $$('[data-gallery-thumb]', el).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ============ quantity ============ */
  function initQty(root) {
    $$('.cl-qty', root).forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      var input = $('input', el);
      $$('button', el).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, v + (b.dataset.step === 'up' ? 1 : -1));
        });
      });
    });
  }

  /* ============ boot ============ */
  function initAll(root) {
    root = root || document;
    initReveals(root); initSeq(root); initConv(root); initCal(root);
    initCounters(root); initRing(root); initIndustries(root); initFloat(root);
    initSequence(root); initProductForm(root); initVariants(root);
    initGallery(root); initQty(root);
    initMenu(); initCart();
  }

  window.CoreLink = window.CoreLink || {};
  window.CoreLink.toast = toast;
  window.CoreLink.refreshCart = refreshCart;
  window.CoreLink.openCart = openDrawer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  requestAnimationFrame(frame);

  document.addEventListener('shopify:section:load', function (e) {
    sequences = sequences.filter(function (s) { return document.contains(s.root); });
    floaters = floaters.filter(function (f) { return document.contains(f); });
    header = null;
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    sequences = sequences.filter(function (s) { return document.contains(s.root); });
    floaters = floaters.filter(function (f) { return document.contains(f); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
